<template>
  <a v-bind="anchorAttrs" @click="onClick">
    <slot> </slot>
  </a>
</template>

<script lang="ts" setup>
  import { extractText } from '../../utils/analytics'
  import type { SlotItem } from "../../utils/analytics";

  const props = defineProps({
    href: {
      type: String,
      default: '#'
    },
    target: {
      type: String
    },
    rel: {
      type: String
    },
    ...Analytics.props
  })

  const emit = defineEmits(['click'])

  const { href, target, rel } = toRefs(props)

  const slots = useSlots()
  const attrs = useAttrs()

  const anchorAttrs = computed(() =>
    _omitBy(
      {
        href: href.value,
        target: target?.value,
        rel: rel?.value,
        ...attrs
      },
      _isNil
    )
  )

  const { linkClick } = Analytics.use()

  const onClick = (ev: any) => {
    try {
      linkClick({
        elementId: anchorAttrs.value?.id,
        linkTo: anchorAttrs.value?.href,
        linkText: extractText((slots?.default?.() as Array<SlotItem>) ?? []),
        ...Analytics.getEventData(props.eventData)
      })
    } catch (ex) {
      console.error(ex)
    }

    emit('click', ev)
  }
</script>

<style scoped></style>
